import cloneDeep from 'lodash.clonedeep';
import { usePortalStore } from '../index.js';

/**
 * Fix routes to have the same length as waypoints
 */
const fixRoutes = () => {
    var _a, _b;
    const portalStore = usePortalStore();
    const { itinerary } = portalStore;
    const routes = (_b = (_a = itinerary.value.routes) === null || _a === void 0 ? void 0 : _a.map((route, index) => {
        var _a, _b, _c, _d;
        return ({
            ...route,
            from: { id: (_b = (_a = itinerary.value.waypoints[index]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '' },
            to: { id: (_d = (_c = itinerary.value.waypoints[index + 1]) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '' },
        });
    })) !== null && _b !== void 0 ? _b : [];
    /** extract waypoint length - 1 routes from routes */
    routes.splice(itinerary.value.waypoints.length - 1, routes.length - itinerary.value.waypoints.length + 1);
    portalStore.itinerary.set.routes(routes, true);
};
/**
 * Fix waypoint start times to be set based on the positions
 * of the waypoints in the itinerary and the itinerary start time
 *
 * If writes are skipped, simply returns the start times
 * and total itinerary duration
 */
const waypointStartTimes = (payload) => {
    const portalStore = usePortalStore();
    const { itinerary } = portalStore;
    if (!itinerary.value.startTime)
        return;
    /**
     * Accumulating date to add to.
     * Cloned to avoid mutating the start time.
     */
    const accumulatingDate = cloneDeep(itinerary.value.startTime);
    const addToCurrentTime = (minutes) => {
        var _a;
        accumulatingDate.timestamp = ((_a = accumulatingDate.timestamp) !== null && _a !== void 0 ? _a : 0)
            + minutes * 60 * 1000;
    };
    itinerary.getters.currentWaypoints().forEach(({ id }, index) => {
        var _a;
        portalStore.waypoints.setChildOf(id, 'date', cloneDeep(accumulatingDate), (payload === null || payload === void 0 ? void 0 : payload.fix) ? 'update waypoint date' : false);
        const totalWaypointDuration = portalStore.waypoints.getters.totalDuration(id);
        addToCurrentTime(totalWaypointDuration);
        const route = (_a = portalStore.itinerary.value.routes) === null || _a === void 0 ? void 0 : _a[index];
        if (!route)
            return;
        addToCurrentTime(route.duration);
    });
    /** Calculate itinerary total time */
    const total = portalStore.itinerary.getters.totalDuration();
    if (total !== portalStore.itinerary.value.duration) {
        portalStore.itinerary.set.duration(total, (payload === null || payload === void 0 ? void 0 : payload.fix) ? 'set itinerary duration' : false);
    }
    const startTimesByWaypointID = Object.fromEntries(portalStore.itinerary.getters.currentWaypoints()
        .map((waypoint) => [waypoint.id, waypoint.date]));
    return {
        startTimesByWaypointID,
        total,
    };
};

export { fixRoutes, waypointStartTimes };
